import $ from 'jquery';
const App = (() => {
	'use strict';

	const bindEvents = () => {
		$(document)
			.on('click', '.anchor-link', handleAnchorLink)
			.on('click', '.page-top a', scrollToTop)
			.on('click', '.js-accordion', handleAccordion)
			.on('click', '.js-close-accordion', handleCloseAccordion);

		$(window).on('load', handleLoadHash);
		$(window).on('load', goToTop);
		$(window).on('scroll', goToTop);
	};

	const handleLoadHash = function () {
		if( window.location.hash && $(window.location.hash).length ) {
			let target = $(window.location.hash).offset().top;
			smoothScrollTo(target - $('.p-header').outerHeight(), 100);
		}
	}

	const handleAccordion = function (e) {
		const $this = $(this);
		$this.toggleClass('is-active').next().slideToggle(300)
	}

	const handleCloseAccordion = function (e) {
		e.preventDefault();
		const $this = $(this);
		$this
		.closest('.accordion-box').slideUp(300)
		.prev().removeClass('is-active')
	}

	const handleAnchorLink = function (e) {
		const isSamePage = location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
			&& location.hostname === this.hostname;

		if (!isSamePage) return;

		const target = findTarget(this.hash);
		if (target.length) {
			e.preventDefault();
			smoothScrollTo(target.offset().top - $('.p-header').outerHeight());
		}
	};

	const scrollToTop = (e) => {
		e.preventDefault();
		smoothScrollTo(0);
	};

	const findTarget = (hash) => {
		const $target = $(hash);
		return $target.length ? $target : $(`[name="${hash.slice(1)}"]`);
	};

	const smoothScrollTo = (position, duration = 500) => {
		$('html, body').animate({ scrollTop: position }, duration);
	};

	const goToTop = () => {
		// タブレット以上のみ実行
		if (window.innerWidth < 768) {
			return; // スマホサイズなら処理を実行しない
		}

		if ($(window).scrollTop() > 100) {
			$('#pageTop').fadeIn();
		} else {
			$('#pageTop').fadeOut();
		}
	};

	return {
		init() {
			bindEvents();
		},

	};
})();
window.addEventListener('DOMContentLoaded', () => {
	App.init();
});
